module.exports = __webpack_public_path__ + "static/media/logo-1.2d5024d0.png";